<template>
     <div>
        <Form  inline  :label-width="80" >
            <FormItem  label="选择时间" >
                <DatePicker
                        split-panels
                        type="daterange"
                        :options="options"
                        placeholder="选择日期"
                        @on-change="modifyTime"
                        :value="valuedate"
                >
                </DatePicker>
            </FormItem>
        </Form>
       
        <div class="card">
            <div class="title" style="background-color: #ff8a73;">
                <Icon type="md-bookmarks" color="#ffffff" size="26" /> <span class="cursor"  @click="$router.push('/surplus')">账户余额 ￥{{pageData.bankmoney}}</span>
            </div>
            <Row style="color: #ff8a73">
                <Col span="12" align="center" class="cursor" @click.native="$router.push('/reconciliation')">应收客户款：￥{{getmoney}}<Icon type="ios-arrow-forward" /></Col>
                <Col span="12" align="center" class="cursor" @click.native="$router.push('/supplier')">应付供应商款：￥{{putmoney}}<Icon type="ios-arrow-forward" /></Col>
            </Row>
        </div>
        <div class="card"  style="color: #62b384" v-if="isroule">
            <div class="title"  style="background-color: #62b384;">
                <Icon type="md-bookmarks" color="#ffffff" size="26" /> 库存成本 ￥{{pageData.stockmoney}}
            </div>
            <Row>
                <Col span="12" align="center" class="cursor">库存数量：{{pageData.sum}}</Col>
                <Col span="12" align="center" class="cursor">库存预警数：{{pageData.warning}}</Col>
            </Row>
        </div>
         <!--经营概况-->
        <div class="card">
           <div class="title">
               <Icon type="md-bookmarks" color="#ffffff" size="26" /> 今日统计 ￥{{pageData.marketmoney}}
           </div>
            <Row>
                <Col span="12" align="center" class="cursor"  @click.native="$router.push('/surplus')">收入：￥{{pageData.marketmoney}}<Icon type="ios-arrow-forward" /></Col>
                <Col span="12" align="center" class="cursor" @click.native="$router.push('/surplus')">支出：￥{{pageData.expend}}<Icon type="ios-arrow-forward" /></Col>
            </Row>
        </div>
        <div class="card allCard">
            <Row @click.native="$router.push('/particular')">
                <Col span="24"  offset="5"><span class="result">销售笔数：{{pageData.xsum}}</span></Col>
                <Col span="24"  offset="5"><span class="result">销售数量：{{pageData.quantity}}</span></Col>
                <Col span="24"  offset="5"><span class="result">销售金额：￥{{alldata.totalMoney}}</span></Col>
                <Col span="24"  offset="5"><span class="result" v-if="isroule">销售毛利：￥{{alldata.grossProfit}}</span></Col>
            </Row>
        </div>
        <div class="card allCard">
            <Row  @click.native="$router.push('/purchase')">
                <Col span="24"  offset="5"><span class="result">采购笔数：{{pageData.csum}}</span></Col>
                <Col span="24"  offset="5"><span class="result">采购数量：{{pageData.cquantity}}</span></Col>
                <Col span="24"  offset="5"><span class="result" v-if="isroule">采购金额：￥{{pageData.pprice}}</span></Col>
            </Row>
        </div>

    </div>
</template>
<script>
    export default {
        data() {
            return {
                cid:'',
                sid:'',
                pageData:{},
                options: {
                    shortcuts: [
                        {
                            text: '昨日',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 *1);
                                return [start, start];
                            },
                        },
                        {
                            text: '今日',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                return [start, end];
                            },
                        },
                        {
                            text: '近七日',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                return [start, end];
                            },

                        }
                    ],
                },
                alldata:{},
                isroule:true,
                customerList:[],
                supplierList:[]
            };
        },
        created: function() {
            //获取用户信息
            this.cid= JSON.parse(localStorage.getItem('shop')).cid
            this.sid = JSON.parse(localStorage.getItem('shop')).id
            this.valuedate[0] = this.fun_date(0)
            this.valuedate[1] = this.nowTime
            this.getManageall(this.valuedate[0],this.valuedate[1])
            var PermisCode=  JSON.parse(sessionStorage.getItem('access')).code
            if(!PermisCode.includes('94')){
                this.isroule=false
            }
            this.getCustomerList()
            this.getSupplierList()        

        },

        methods: {
            //获取盘点列表
            getManageall(startTime,endTime){
                this.$Api.getManageall({
                    cid: this.cid,
                    sid: this.sid,
                    beantime: startTime,
                    endtime:endTime,
                }).then(res => {
                    if(res.code==200){
                        this.pageData=res.data
                        this.getMarketData(startTime,endTime)
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });

            },
            modifyTime(data){
                this.valuedate[0] = data[0]
                this.valuedate[1] = data[1]
                this.getManageall(this.valuedate[0],this.valuedate[1])
            },

             
            getMarketData(startTime,endTime){
                this.$Api.getMarketData({
                    cid: this.cid,
                    sid: this.sid,
                    time: startTime,
                    endtime:endTime,
                }).then(res => {
                    if(res.code==200){
                        this.alldata=res.data
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },
            
          

            //获取客户列表
            getCustomerList(){
                this.$Api.getCustomerList({
                    cid: this.cid,
                    sid: this.sid,
                    page: 1,
                    rows: 1000
                }).then(res => {
                    if(res.code==200){
                        this.customerList = res.data
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });

            },
            //获取供应商列表
     
            getSupplierList(){
                this.$Api.getSupplierList({
                    cid: this.cid,
                    sid: this.sid,
                    page: 1,
                    rows: 1000
                }).then(res => {
                    if(res.code==200){
                        this.supplierList = res.data
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });

            },



        },
         computed: {
            getmoney() {
            let aa = 0;
            for (let i = 0; i < this.customerList.length; i++) {
                if (this.customerList[i].money < 0) {
                aa += this.customerList[i].money;
                }
            }
            return -aa.toFixed(2);
            },
            putmoney() {
            let aa = 0;
            for (let i = 0; i < this.supplierList.length; i++) {
                if (this.supplierList[i].money > 0) {
                aa += this.supplierList[i].money;
                }
            }
            return aa.toFixed(2);
            }
        },
    };
</script>

<style lang="scss" scoped>

.card{
    width: 30%;
    height: 200px;
    background-color: #ffffff;
    box-shadow: 0px 3px 10px 0px
    rgba(24, 54, 129, 0.14);
    border-radius: 4px;
    margin: 15px;
    display: inline-block;
    overflow: hidden;
    color: #739aff;
    .title{
        width: 100%;
        height: 78px;
        background-color: #739aff;
        border-radius: 4px 4px 0px 0px;
        margin-bottom: 50px;
        color: #ffffff;
        padding:40px 10px 0;
        font-size: 18px;
    }
}
    .result{
        display: block;
        padding-top: 20px;
        color: #666666;
        cursor: pointer;
    }
    .allCard {
        width: 30%;
        height: 205px;
        display: inline-block;
        padding-top: 20px;

    }
    .cursor{
        cursor: pointer;
    }
</style>